// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"6":"5ca0b930","282":"7fb6f706","653":"eaff45d0","706":"00486d25"}[chunkId] + ".chunk.js";
};